import { useTranslation } from 'react-i18next';
import { PenLine, Wand2, Library } from 'lucide-react';

/** Explique le processus de capture (raconte → l'IA range → c'est classé). */
export function CaptureIntro() {
  const { t } = useTranslation();
  const steps = [
    { icon: PenLine, title: t('capture.step1Title'), body: t('capture.step1') },
    { icon: Wand2, title: t('capture.step2Title'), body: t('capture.step2') },
    { icon: Library, title: t('capture.step3Title'), body: t('capture.step3') },
  ];
  return (
    <div className="mx-auto flex h-full max-w-xl flex-col justify-center gap-6 py-6">
      <div className="text-center">
        <h2 className="text-xl font-semibold">{t('capture.introTitle')}</h2>
        <p className="mt-1 text-sm text-muted">{t('capture.introSubtitle')}</p>
      </div>
      <ol className="space-y-3">
        {steps.map((s, i) => (
          <li key={i} className="flex items-start gap-3 rounded-xl bg-surface px-4 py-3 ring-1 ring-border">
            <span className="mt-0.5 grid h-8 w-8 shrink-0 place-items-center rounded-lg bg-accent/15 text-accent">
              <s.icon className="h-4 w-4" />
            </span>
            <div>
              <p className="text-sm font-medium">{s.title}</p>
              <p className="text-sm text-muted">{s.body}</p>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}
